import React from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'antd';
import History from '../../util/history';

const Loading = (props) => {
    if (props.isLoading) {
        if (props.timedOut) {
            return null;
        } else if (props.pastDelay) {
            return null;
        } else {
            return null;
        }
    } else if (props.error) {
        return LoadingError(props);
    } else {
        return null;
    }
};

const LoadingError = (props) => {
    const { intlr } = props;
    const handleCancel = () => {
        History.replace('/');
    };
    return (
        <Modal
            width={320}
            visible={true}
            onCancel={handleCancel}
            footer={null}>
            <h3 style={{textAlign: 'center', paddingBottom: '20px'}}>{intlr.messages['NETWORK.ERR.MSG']}</h3>
            <Button block type="primary" onClick={props.retry}>
                {intlr.messages['HARDDRIVER.OK_BUTTON']}
            </Button>
        </Modal>
    );
};

const mapStateToProps = state => ({
    intlr: state.intlr
});

export default connect(
    mapStateToProps
)(Loading);